module.exports = __webpack_public_path__ + "109b5c297db633dbf3eb0a8e932ac67b.svg";